export default "__VITE_ASSET__Chx0$In$__"